import { Locale, Realm } from '../../services/i18nService';
import React, { Context } from 'react';

export type AppShopContextHolder = {
  siteId: number;
  domain: string;
  realm: Realm;
  locale: Locale;
};

const appShopContext: AppShopContextHolder = {
  siteId: 11,
  domain: 'zooplus.ie',
  realm: 'zooplus',
  locale: 'en_IE',
};

const allowedRealms = new Set(
  (process.env.REACT_APP_ALLOWED_REALMS || '').split(',').map((it) => it.trim()),
);

const allowedDomains = new Set(
  (process.env.REACT_APP_ALLOWED_DOMAINS || '').split(',').map((it) => it.trim()),
);

export const AppShopContext: Context<AppShopContextHolder> = React.createContext(appShopContext);
export const validateAppShopContext = function (context: AppShopContextHolder): void {
  let errorMessage: string = '';
  let errorMessageCreator = (paramName: string) => `Value of [${paramName}] is invalid`;
  if (!context.locale) {
    errorMessage = errorMessageCreator('locale');
  }
  if (!context.domain || !allowedDomains.has(context.domain)) {
    errorMessage = errorMessageCreator('domain');
  }
  if (!context.realm || !allowedRealms.has(context.realm)) {
    errorMessage = errorMessageCreator('realm');
  }
  if (typeof context.siteId != 'number' || Number.isNaN(context.siteId) || context.siteId <= 0) {
    errorMessage = errorMessageCreator('site id');
  }

  if (errorMessage) {
    throw new Error(errorMessage);
  }
};
